import axios from "axios";

import { ensureCsrfToken } from "../../../../lib/csrf";

export const PORTFOLIO_CAPITAL_OPTIMIZATION_URL =
  "/api/digital-risk/dashboard/portfolio-capital-optimization/";

export async function evaluateManagementCapitalConstraint({
  availableCapital,
  scenarioIds,
  simulations,
  seed,
}) {
  if (!Number.isFinite(Number(availableCapital)) || Number(availableCapital) < 0) {
    throw new Error("Management Requested Capital must be a non-negative number.");
  }
  if (!Array.isArray(scenarioIds) || scenarioIds.length === 0) {
    throw new Error("Accepted optimizer scenario scope is unavailable.");
  }
  if (!Number.isInteger(simulations) || simulations <= 0) {
    throw new Error("Accepted optimizer simulation context is unavailable.");
  }

  const csrfToken = await ensureCsrfToken();
  const { data } = await axios.post(
    PORTFOLIO_CAPITAL_OPTIMIZATION_URL,
    {
      available_capital: Number(availableCapital),
      // Preserve the accepted authority's exact scenario universe and run inputs.
      scenario_ids: [...scenarioIds],
      simulations,
      seed,
    },
    {
      withCredentials: true,
      headers: { "X-CSRFToken": csrfToken },
    }
  );
  return data;
}
